
/** @format */

import React, { useEffect } from 'react';
import { Grid, FormControlLabel, Typography, RadioGroup, Radio } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { GuildsSelect, InputCurrency, InputV2 } from 'components';
import { useStyles } from './style';
import clsx from 'clsx';

const BaseInfo = ({ voucherType, setVoucherType }) => {
  // -- HOOKS --//
  const methods = useFormContext();
  const classes = useStyles();

  useEffect(() => {
    methods.register('guildCode');
    return () => {
      methods.unregister('guildCode');
    };
  }, [methods.register, methods.unregister]);

  return (
    <Grid container direction="row" alignItems="center" spacing={2} item xs={12} lg={6} md={9}>
      <Grid item xs={12}>
        <RadioGroup
          row
          xs={12}
          required
          onChange={(e) => {
            setVoucherType(e?.target?.value);
          }}
          value={voucherType}
          className={classes.options}
          defaultValue={voucherType}
        >
          <Grid container xs={12} justifyContent="flex-start">
            <FormControlLabel
              value="amount"
              className={clsx(classes.radioItem, {
                active: voucherType === 'amount',
              })}
              control={<Radio style={{ display: 'none' }} />}
              label={
                <Typography
                  className={clsx(classes.radioText, {
                    active: voucherType === 'amount',
                  })}
                >
                  مبلغ ثابت
                </Typography>
              }
            />
            <FormControlLabel
              value="percentage"
              className={clsx(classes.radioItem, {
                active: voucherType === 'percentage',
              })}
              control={<Radio style={{ display: 'none' }} />}
              label={
                <Typography
                  className={clsx(classes.radioText, {
                    active: voucherType === 'percentage',
                  })}
                >
                  درصد فاکتور
                </Typography>
              }
            />
          </Grid>
        </RadioGroup>
      </Grid>

      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="نام بن"
          errors={methods.formState.errors}
          name="name"
          register={methods.register}
          rules={['required' , 'isNotContainTag']}
          control={methods.control}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="تعداد بن تخفیف قابل صدور"
          errors={methods.formState.errors}
          tooltip="به تعداد عددی که در این قسمت وارد کنید کد تخفیف یکتا با مشخصات وارد شده تولید خواهد شد."
          name="count"
          register={methods.register}
          rules={['required', 'isNumeric', 'isMin|0']}
          control={methods.control}
          currency
          decimalPlaces={0}
          minimumValue={0}
          currencyText="عدد"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <GuildsSelect
          methods={methods}
          singleSelect
          name="guildCode"
          showBusinessGuilds={true}
          label="حساب تفصیلی حوزه مصرف بن"
          rules={['required']}
        />
      </Grid>

      <Grid item xs={12}>
        <InputV2
          label="توضیحات"
          multiline
          fullWidth
          rows={5}
          errors={methods.formState.errors}
          name="description"
          register={methods.register}
          rules={['required' , 'isNotContainTag']}
          control={methods.control}
        />
      </Grid>

      {voucherType === 'amount' ? (
        <Grid item xs={12} md={6}>
          <InputCurrency
            fullWidth
            label="مبلغ بن تخفیف"
            errors={methods.formState.errors}
            name="amount"
            register={methods.register}
            rules={['required', 'isNumeric', 'isMin|0']}
            control={methods.control}
            minimumValue={0}
            decimalPlaces={0}
            englishNumber
          />
        </Grid>
      ) : (
        <>
          <Grid item xs={12} md={6}>
            <InputV2
              fullWidth
              label="درصد تخفیف"
              errors={methods.formState.errors}
              name="discountPercentage"
              register={methods.register}
              rules={['required', 'isNumeric', 'isMin|0', 'isMax|100']}
              control={methods.control}
              minimumValue={0}
              currency
              maximumValue={100}
              currencyText="%"
              englishNumber
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <InputCurrency
              label="سقف تخفیف"
              fullWidth
              tooltip="حداکثر مبلغی که از مبلغ فاکتور استفاده کننده این کد تخفیف، کسر خواهد شد."
              errors={methods.formState.errors}
              name="amount"
              register={methods.register}
              rules={['required', 'isNumeric', 'isMin|0']}
              control={methods.control}
              minimumValue={0}
              decimalPlaces={0}
              englishNumber
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};



export default BaseInfo;
